import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Lightbulb, X } from 'lucide-react';

function HelpWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating button */}
      <button
        className="help-fab"
        onClick={() => setIsOpen(!isOpen)}
        title="Não sabe o que falar?"
      >
        {isOpen ? (
          <X size={18} />
        ) : (
          <Lightbulb size={18} />
        )}
      </button>

      {/* Floating card */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="help-widget-card"
            initial={{ opacity: 0, y: 12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.95 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
          >
            <div className="help-widget-header">
              <Lightbulb size={16} className="help-widget-icon" />
              <span className="help-widget-title">Travou? Sem problema.</span>
              <button className="help-widget-close" onClick={() => setIsOpen(false)}>
                <X size={14} />
              </button>
            </div>
            <div className="help-widget-content">
              <p className="help-widget-label">Diga:</p>
              <p className="help-widget-phrase">
                "<span className="help-widget-phrase-bold">Não entendi.</span>{' '}
                <span className="help-widget-phrase-light">
                  Explica em português.
                </span>"
              </p>
              <div className="help-widget-divider" />
              <p className="help-widget-tip">
                <i className="fa-solid fa-compass help-widget-tip-icon" />
                Esqueceu uma palavra? Use a <strong>Bússola</strong> <i className="fa-solid fa-arrow-right help-widget-tip-arrow" />
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default HelpWidget;
